import React, { memo, useCallback } from "react";

interface ReportsSearchProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  reportsCount: number;
  onClose?: () => void;
}

const ReportsSearch: React.FC<ReportsSearchProps> = memo(
  ({ searchTerm, onSearchChange, reportsCount, onClose }) => {
    const handleSearchChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        onSearchChange(e.target.value);
      },
      [onSearchChange]
    );

    const handleClearSearch = useCallback(() => {
      onSearchChange("");
    }, [onSearchChange]);

    return (
      <div className="reports-list-header">
        <div className="header-top">
          <h3>Reports ({reportsCount})</h3>
          {onClose && (
            <button
              className="close-button"
              onClick={onClose}
              aria-label="Close sidebar"
            >
              ×
            </button>
          )}
        </div>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search reports..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input"
          />
          {searchTerm && (
            <button
              className="clear-search-btn"
              onClick={handleClearSearch}
              title="Clear search"
              aria-label="Clear search"
            >
              ×
            </button>
          )}
        </div>
      </div>
    );
  }
);

ReportsSearch.displayName = "ReportsSearch";

export default ReportsSearch;
